import type {
  InventoryCategoryRecord,
  InventoryUnitRecord,
  SaveInventoryCategoryRequest,
  SaveInventoryUnitRequest,
} from '@/renderer/types/inventory';

export interface InventoryCategoryFormState {
  name: string;
  description: string;
  isActive: boolean;
}

export interface InventoryUnitFormState {
  name: string;
  abbreviation: string;
  isActive: boolean;
}

export const createEmptyInventoryCategoryForm =
  (): InventoryCategoryFormState => ({
    name: '',
    description: '',
    isActive: true,
  });

export const createInventoryCategoryFormFromRecord = (
  record: InventoryCategoryRecord,
): InventoryCategoryFormState => ({
  name: record.name,
  description: record.description ?? '',
  isActive: record.is_active,
});

export const buildSaveInventoryCategoryPayload = (
  companyId: number,
  form: InventoryCategoryFormState,
  categoryId?: string,
): SaveInventoryCategoryRequest => ({
  id: categoryId,
  companyId,
  name: form.name.trim(),
  description: form.description.trim() || null,
  isActive: form.isActive,
});

export const createEmptyInventoryUnitForm = (): InventoryUnitFormState => ({
  name: '',
  abbreviation: '',
  isActive: true,
});

export const createInventoryUnitFormFromRecord = (
  record: InventoryUnitRecord,
): InventoryUnitFormState => ({
  name: record.name,
  abbreviation: record.abbreviation ?? '',
  isActive: record.is_active,
});

export const buildSaveInventoryUnitPayload = (
  companyId: number,
  form: InventoryUnitFormState,
  unitId?: string,
): SaveInventoryUnitRequest => ({
  id: unitId,
  companyId,
  name: form.name.trim(),
  abbreviation: form.abbreviation.trim() || null,
  isActive: form.isActive,
});
